/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React } from "react";
import { default as Styles } from "./InputErrorMessage.module.scss";
import { qa } from "../../../utils/qa";

interface Props {
  errorMessage: string;
}

const InputErrorMessage = ({ errorMessage }: Props) => {
  return (
    <div className={Styles.errorMessage} data-qa-id={qa("input_errorMessage")}>
      {/* SB-259 Add icon on message for Starbreeze: START */}
      <i className={"icon-ab-warning-circle-filled"} />
      {/* SB-259 Add icon on message for Starbreeze: END */}
      {errorMessage}
    </div>
  );
};

export default InputErrorMessage;
